import React from "react"
import Numeral from "numeral"
import {RaisedButton } from "material-ui"
import TrendCompareGraph from "../../components/misc/TrendCompareGraph"
import AccountStore from "../../stores/AccountStore"
import strings from "../../localization/strings"
import AppStateStore from "../../stores/AppStateStore"
interface IProps {

}

const AccountBilling: React.SFC<IProps> = (props: IProps) => {
    const accountStats = AccountStore.getCurrentAccountSettings().AccountStats
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    })
    return (
        <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ flex: 2 }}>
                <div style={{ float: "left", minWidth: 450, width: "46%", padding: 20, marginTop: 30, marginBottom: 20 }}                            >
                    {AccountStore.getCurrentAccountSettings().CalculateBillingByDevice ?
                        <div>
                            <div style={{ width: "50%", float: "left", textAlign: "center" }}>
                                <div className="graph-top-title">{strings.Active_Employee_Devices}</div>
                                <div className="graph-top-title">
                                    {accountStats ?
                                        Numeral(accountStats.CurrentMonthTotalActiveEmployees).format("0,0") : 0
                                    }
                                </div>
                            </div>
                            <div style={{ width: "50%", float: "left", textAlign: "center" }}>
                                <div className="graph-top-title">{strings.Active_Clock_Devices}</div>
                                <div className="graph-top-title">
                                    {accountStats ?
                                        Numeral(accountStats.CurrentMonthTotalActiveClocks).format("0,0") : 0
                                    }
                                </div>
                            </div>
                            <TrendCompareGraph
                                data1={accountStats.TotalActiveEmployeesPast12Months}
                                data2={accountStats.TotalActiveClockDevicesPast12Months}
                                label1={strings.Employees}
                                label2={strings.Clocks}
                            />
                            <div style={{ marginTop: "35px" }}>
                                {AccountStore.getCurrentAccount().BillingInfo &&
                                    <div style={{ width: "50%", margin: "0 auto", textAlign: "left" }}>
                                        <div className="graph-bottom-title">
                                            {formatter.format(AccountStore.getCurrentAccount().BillingInfo.PerEmployeePerMonthRate)} <span style={{ fontSize: 12 }}>{strings.Per_Employee_Month}</span>
                                        </div>
                                        <div className="graph-bottom-title">
                                            {formatter.format(AccountStore.getCurrentAccount().BillingInfo.PerClockPerMonthRate)} <span style={{ fontSize: 12 }}>{strings.Per_Clock_Month}</span>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div> :
                        <div>
                            <div style={{ width: "100%", float: "left", textAlign: "center" }}>
                                <div className="graph-top-title">{strings.Active_Employees}</div>
                                <div className="graph-top-title">
                                    {accountStats ?
                                        Numeral(accountStats.CurrentMonthTotalActiveEmployees).format("0,0") : 0
                                    }
                                </div>
                            </div>
                            <TrendCompareGraph
                                data1={accountStats.TotalActiveEmployeesPast12Months}
                                label1={strings.Active}
                            />
                            <div style={{ marginTop: "35px" }}>
                                {AccountStore.getCurrentAccount().BillingInfo &&
                                    <div style={{ width: "50%", margin: "0 auto", textAlign: "left" }}>
                                        <div className="graph-bottom-title">
                                            {formatter.format(AccountStore.getCurrentAccount().BillingInfo.PerEmployeePerMonthRate)} <span style={{ fontSize: 12 }}>{strings.Per_Employee_Month}</span>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>}
                </div>
                <div style={{ float: "left", minWidth: 450, width: "46%", padding: 20, marginTop: 30, marginBottom: 20 }}                            >
                <RaisedButton
                    data-intercom-target={"menu-AccountSettings-AccrualAdjustmentRules-Btn-CloseAdjustmentDialog"}
                    label={"View Billing Details"}
                    secondary
                    onTouchTap={()=>{AppStateStore.openAccountBillingDrawer()}}
                    />                    
                </div>
            </div>
        </div>
    )
}

export default AccountBilling
